<div *ngIf="isLoading" class="overlay" id="overlay">
    <span style="font-size: 16px">{{messageLoading}}</span>
</div>
<div class="overlay" *ngIf="isError" id="overlay">
    <span style="font-size: 16px">Lỗi kết nối</span>
</div>
